import { PIXI } from 'expo-pixi';
const { Rectangle, Texture } = PIXI;
async function setupSpriteSheetAsync(resource, bird0, bird1, bird2, pipe, ground, background, spriteSheet) {
  const texture = await Texture.fromExpoAsync(resource);
  const birdTexture0 = await Texture.fromExpoAsync(bird0)
  const birdTexture1 = await Texture.fromExpoAsync(bird1)
  const birdTexture2 = await Texture.fromExpoAsync(bird2)
  const pipeTexture = await Texture.fromExpoAsync(pipe)
  const groundTexture = await Texture.fromExpoAsync(ground)
  const backgroundTexture = await Texture.fromExpoAsync(background)

  let textures = {};
  for (const sprite of spriteSheet) {
    const { name, x, y, width, height } = sprite;
    try {
      const frame = new Rectangle(x, y, width, height);
      switch(name){
        case 'bird_000':
          textures[name] = new global.PIXI.Texture(birdTexture0.baseTexture, frame);
          break;
        case 'bird_001':
          textures[name] = new global.PIXI.Texture(birdTexture1.baseTexture, frame);
          break;
        case 'bird_002':
          textures[name] = new global.PIXI.Texture(birdTexture2.baseTexture, frame);
          break;
        case 'ground':
          textures[name] = textures[name] = new global.PIXI.Texture(texture.baseTexture, frame);
          break;
        case 'background':
          textures[name] = new global.PIXI.Texture(backgroundTexture.baseTexture, frame);
          break;  
        case 'pipe':
          textures[name] = new global.PIXI.Texture(pipeTexture.baseTexture, frame);
          break;   
        default:
          break;
      }
    } catch ({ message }) {
      console.error(message);
    }
  }
  return textures;
}

export default setupSpriteSheetAsync;
